import api from "./index";

/**
 * Serviço para iniciar o processamento assíncrono do relatório de produtos contratuais
 * @param {string} token - Token de autenticação
 * @param {object} data - Objeto contendo eventIdList
 * @returns {Promise} Resposta da API com reportId
 */
export const startContractualProductsReportService = async (token, data) => {
  return await api.post(`/async/Contractual-Products-Report-for-Partners`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

/**
 * Serviço para verificar o status do processamento do relatório
 * @param {string} token - Token de autenticação
 * @param {string} reportId - ID do relatório
 * @returns {Promise} Resposta da API com status e downloadUrl
 */
export const getContractualProductsReportStatusService = async (
  token,
  reportId
) => {
  return await api.get(`/async/Contractual-Products-Report-for-Partners/${reportId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
